// extracted by mini-css-extract-plugin
export var auth = "ShellTopBar-module--auth--c5f5c";
export var bar = "ShellTopBar-module--bar--1486f";
export var betslip = "ShellTopBar-module--betslip--2a9af";
export var dockTrigger = "ShellTopBar-module--dockTrigger--27c6a";
export var leading = "ShellTopBar-module--leading--5e292";
export var notifications = "ShellTopBar-module--notifications--f0d4f";
export var notificationsHeader = "ShellTopBar-module--notificationsHeader--7900a";
export var perk = "ShellTopBar-module--perk--6f99f";
export var perkBadge = "ShellTopBar-module--perkBadge--f7fe3";
export var perkIcon = "ShellTopBar-module--perkIcon--e65d2";
export var perkInfo = "ShellTopBar-module--perkInfo--03b1c";
export var perkName = "ShellTopBar-module--perkName--952e7";
export var perkPill = "ShellTopBar-module--perkPill--552cb";
export var perks = "ShellTopBar-module--perks--c2f0a";
export var perksPopover = "ShellTopBar-module--perksPopover--3fa68";
export var pill = "ShellTopBar-module--pill--42895";
export var pillNotice = "ShellTopBar-module--pillNotice--d5658";
export var popover = "ShellTopBar-module--popover--ff8ad";
export var searchPopover = "ShellTopBar-module--searchPopover--f6ef3";